import { render, staticRenderFns } from "./MyWalletUnclaimedGasSection.vue?vue&type=template&id=29b3a272&scoped=true"
import script from "./MyWalletUnclaimedGasSection.vue?vue&type=script&lang=ts"
export * from "./MyWalletUnclaimedGasSection.vue?vue&type=script&lang=ts"
import style0 from "./MyWalletUnclaimedGasSection.vue?vue&type=style&index=0&id=29b3a272&prod&lang=scss&scoped=true"
import style1 from "./MyWalletUnclaimedGasSection.vue?vue&type=style&index=1&id=29b3a272&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b3a272",
  null
  
)

export default component.exports